/**
 * Revokes an object URL created for an attachment preview to free up memory.
 * @param {Object} attachment - Attachment object with optional previewUrl
 */
export const revokeAttachmentPreview = (attachment) => {
    if (attachment?.previewUrl) {
        URL.revokeObjectURL(attachment.previewUrl);
    }
};
